module.exports = __webpack_public_path__ + "static/img/base-img4.4099349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCodePhone/base-img4.png
// module id = F18G
// module chunks = 0